<template>
  <div class="payMethod-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="channelOperation('add')" class="add-input">+新增支付方式</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" >
      <el-table-column prop="channelName" label="支付平台" align="center" fixed min-width="180">
        <template slot-scope="scope">
          <span>{{scope.row.channelName || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cid" label="平台ID" align="center" fixed min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.cid || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payType" label="支付方式" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.payType | payTypeRule}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minMoney" label="最小支持金额(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.minMoney/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ƒ" label="最大支持金额(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.maxMoney/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="权重" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.weight || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="category" label="支付金额类型" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.category=='fixed'?'固定':'活动'}}</span>
        </template>
      </el-table-column>
            <el-table-column prop="amountTypes" label="金额种类" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.amountTypes | amountTypesFun}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="渠道费率" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.rate || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="activePeriod" label="激活时间段" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.activePeriod || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="active" label="激活状态" align="center" min-width="150">
        <template slot-scope="scope">
          <el-switch disabled v-model="scope.row.active"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="240">

        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="240">

        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="channelOperation('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeChannel(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <channel-action ref="channelAction" @handlerChannelList="getChannelList"></channel-action>
  </div>
</template>

<script>
import API from '@/api'
import ChannelAction from "./components/channelAction"
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0
    }
  },
  components: {
    ChannelAction
  },
  created() {
    this.getChannelList()
  },
  methods: {
    // 请求支付方式列表
    getChannelList() {
      this.loading = true;
      API.getChannelList().then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除支付方式配置
    removeChannel(id) {
      this.$confirm('您确定要删除当前支付方式吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.delChannel({ ids: [id] }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除支付方式成功',
                type: 'success'
              })
              this.getChannelList()
            } else {
              this.$message.error('删除支付方式失败')
            }
          })
        })
        .catch(() => { });
    },
    // 新增、编辑操作
    channelOperation(type, data) {
      this.$refs.channelAction.open(type, data)
    }
  }
}
</script>

<style lang="scss">
.payMethod {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
